import React from 'react';

interface OwnProps {
  customTitle?: string;
  title: string;
}

const TitleBlock = (props: OwnProps) => {
  const { customTitle, title } = props;

  return <div className="TitleBlock">{customTitle || title}</div>;
};

export default TitleBlock;
